function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 1a1 1 0 011 1v2.05c5.053.501 9 4.765 9 9.95v3c0 .77.094 2.104.38 3.528.29 1.437.757 2.874 1.452 3.917A1 1 0 0127 26H5a1 1 0 01-.832-1.555c.695-1.043 1.163-2.48 1.452-3.917C5.906 19.104 6 17.77 6 17v-3c0-5.185 3.947-9.449 9-9.95V2a1 1 0 011-1zM8 14a8 8 0 1116 0v3c0 .897.106 2.363.42 3.922.2 1 .494 2.075.921 3.078H6.66c.427-1.003.72-2.079.921-3.078C7.894 19.363 8 17.897 8 17v-3z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 27a2 2 0 104 0h2a4 4 0 01-8 0h2z",
  fill: "currentColor"
})));